'use strict';

var previewPlayback = {
    timeoutId: -1,
    intent: null,

    // ignore playback during asynchronous channel loading
    active: true
};

/**
 * Send playback intent for TV channel preview.
 *
 * @param {Object} tvChannel - TV channel metadata
 * @param {Object} viewport - player coordinates
 */
function playIntent ( tvChannel, viewport ) {
    if ( previewPlayback.active ) {
        previewPlayback.intent = core.intent({
            action: 'play',
            mime: 'content/video',
            silent: true,
            data: {
                title: tvChannel.name,
                uri: tvChannel.url,
                solution: tvChannel.solution,
                viewport: {
                    x: viewport.left,
                    y: viewport.top,
                    width: viewport.width + 2,
                    height: viewport.height + 2
                },
                displayOnTop: true,
                aspect: 0
            }
        }, function () {
            /* callback code */
        });
    }
}


/**
 * Play TV channel when content item card is under focus.
 *
 * @param {Element} $node - list item
 * @param {Object} tvChannel - TV channel
 */
function playOnFocus ( $node, tvChannel ) {
    var viewport;

    previewPlayback.timeoutId = $node.timeoutId = setTimeout(function () {
        if ( typeof tvChannel.url === 'function' ) {
            tvChannel.url(function ( error, tvChannelInfo ) {
                if ( error ) {
                    return;
                }

                if ( tvChannel.url ) {
                    viewport = $node.$container.getBoundingClientRect();
                    playIntent({
                        name: tvChannel.name,
                        url: tvChannelInfo.url,
                        solution: tvChannelInfo.solution
                    }, viewport);
                }
            });
        } else if ( typeof tvChannel.url === 'string' ) {
            viewport = $node.$container.getBoundingClientRect();
            playIntent(tvChannel, viewport);
        }
    }, 2000);
}


function stopPlayback () {
    clearTimeout(previewPlayback.timeoutId);

    if ( previewPlayback.intent !== null ) {
        previewPlayback.intent.emit('playback:stop');
        previewPlayback.intent = null;
    }
}


if ( DEVELOP ) {
    window.addEventListener('unload', stopPlayback);
}


/**
 * Render function.
 *
 * @this Object
 *
 * @param {Element} $node - list item
 */
function render ( $node ) {
    var number = this.data.number;

    $node.className = 'content-item-tv';

    $node.$shadow = $node.appendChild(document.createElement('div'));
    $node.$shadow.className = 'content-item-tv-shadow';

    $node.$container = $node.appendChild(document.createElement('div'));
    $node.$container.className = 'content-item-tv-container';

    $node.$icon = $node.$container.appendChild(document.createElement('div'));
    $node.$icon.className = 'content-item-tv-icon';
    $node.$icon.style.backgroundImage = 'url("' + this.data.icon.normal + '")';

    $node.$info = $node.$container.appendChild(document.createElement('div'));
    $node.$info.className = 'content-item-tv-info';

    $node.$index = $node.$info.appendChild(document.createElement('div'));
    $node.$index.className = 'content-item-tv-index';

    $node.$description = $node.$info.appendChild(document.createElement('div'));
    $node.$description.className = 'content-item-tv-description';
    $node.$description.innerText = this.data.name;

    $node.$channelInfo = $node.appendChild(document.createElement('div'));
    $node.$channelInfo.className = 'content-item-tv-channel-info';

    $node.$channelDescription = $node.appendChild(document.createElement('div'));
    $node.$channelDescription.className = 'content-item-tv-channel-description';

    if ( this.runApp ) {
        // See more button
        $node.$channelInfo.innerText = this.data.name;
        // $node.$channelDescription.innerText = this.data.name;
    } else {
        $node.$index.innerText = number;
        $node.$channelInfo.innerText = number + '. ' + this.data.name;
    }
    // if ( number ) {
    //     ;
    // } else {
    //     $node.$info.innerHTML = this.data.name;
    // }
    if ( this.data.program && this.data.program.name ) {
        $node.$channelDescription.innerText = this.data.program.name;
    }

    // $node.$channelDescription.innerText = 'New York Stories with Joe Pascal.    The Bacon Brothers. Talking Business asdas d asd asd asd asd';

    // setTimeout(function () {
    //     $node.coords = $node.getBoundingClientRect();
    //     $node.coords.offset = 20 + $node.coords.width;
    // }, 0);
}

core.addListeners({
    blur: function () {
        previewPlayback.active = false;
        stopPlayback();
    },
    focus: function () {
        previewPlayback.active = true;
    }
});

module.exports = {
    render: render,

    focus: function ( $node ) {
        $node.$shadow.className = 'content-item-tv-shadow--focus';
        $node.$container.className = 'content-item-tv-container--focus';
        $node.$icon.className = 'content-item-tv-icon--focus';
        $node.$info.className = 'content-item-tv-info--focus';
        $node.$index.className = 'content-item-tv-index--focus';
        $node.$description.className = 'content-item-tv-description--focus';
        $node.$channelInfo.className = 'content-item-tv-channel-info--focus';
        $node.$channelDescription.className = 'content-item-tv-channel-description--focus';

        //$node.$icon.style.backgroundImage = 'url("' + this.data.icon.active + '")';

        if ( !this.data.censored ) {
            playOnFocus($node, this.data);
        }
    },

    blur: function ( $node ) {
        $node.$shadow.className = 'content-item-tv-shadow';
        $node.$container.className = 'content-item-tv-container';
        $node.$icon.className = 'content-item-tv-icon';
        $node.$info.className = 'content-item-tv-info';
        $node.$index.className = 'content-item-tv-index';
        $node.$description.className = 'content-item-tv-description';
        $node.$channelInfo.className = 'content-item-tv-channel-info';
        $node.$channelDescription.className = 'content-item-tv-channel-description';

        //$node.$icon.style.backgroundImage = 'url("' + this.data.icon.normal + '")';

        stopPlayback();
    }
};
